import { render, staticRenderFns } from "./SingleRing.vue?vue&type=template&id=3f1859b3&scoped=true&lang=pug"
import script from "./SingleRing.vue?vue&type=script&lang=js"
export * from "./SingleRing.vue?vue&type=script&lang=js"
import style0 from "./SingleRing.vue?vue&type=style&index=0&id=3f1859b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1859b3",
  null
  
)

export default component.exports